import styled from '@emotion/styled';

export const TypicalLunchWrapper = styled.div``;
